import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { DotsThreeCircleVerticalIcon, PencilSimpleIcon } from '@phosphor-icons/react'

import {
  ButtonMenu,
  IconButton,
  Loading,
  PartialSummary,
  summaryHelpers,
  Text,
  ToastContext,
} from '@reveni-io/reveni-ui'

import useCustomLogisticsLabel from '@/common/hooks/useCustomLogisticsLabel/useCustomLogisticsLabel'
import RMAContext from '@/returns/pages/TransactionRMAPage/context/RMAContext'
import { getAvailableConcepts } from '@/returns/pages/TransactionRMAPage/helpers'

import EditAmountsDrawer from './EditAmountsDrawer/EditAmountsDrawer'
import useEditAmounts from './hooks/useEditAmounts'
import { getRefundMethodsOptions } from './helpers'
import * as Styles from './styles'

const BreakDown = ({ loadingBreakdown }) => {
  const { rmaInfo } = useContext(RMAContext)
  const { setToastInfo } = useContext(ToastContext)
  const { getSelectedProductsAmount, getSummaryProductItems, getNewProductsItems, getNewProductsAmount } =
    summaryHelpers()

  const { t } = useTranslation()
  const customLogisticsLabel = useCustomLogisticsLabel()
  const {
    gettingRmaAmounts,
    handleOnclickChangeAmounts,
    showEditAmountDrawer,
    onSaveEditAmounts,
    savingEditedRmaAmounts,
    closeEditAmountDrawer,
  } = useEditAmounts({ setToastInfo })

  return (
    <>
      <Styles.TitleContainer>
        <Text type="titleS">{t('Desglose')}</Text>
        <ButtonMenu
          menuItems={[
            {
              label: (
                <Styles.MenuOptionLabel>
                  <PencilSimpleIcon />
                  {t('Editar')}
                </Styles.MenuOptionLabel>
              ),
              onClick: handleOnclickChangeAmounts,
              disabled: rmaInfo?.items?.length === 0 && !rmaInfo?.orderInfo?.deliveryMethod,
            },
          ]}
          renderButton={onOpen => (
            <IconButton
              onClick={onOpen}
              variant="text"
              icon={<DotsThreeCircleVerticalIcon data-testid="menuButton" size={24} />}
            />
          )}
        />
      </Styles.TitleContainer>
      <Loading show={loadingBreakdown || savingEditedRmaAmounts} height="150px">
        <PartialSummary
          total={rmaInfo.orderAmount?.remaining_amount}
          productsToReturn={{
            total: getSelectedProductsAmount(rmaInfo?.items),
            products: getSummaryProductItems(rmaInfo?.items),
          }}
          newRequestedProducts={{
            total: getNewProductsAmount(rmaInfo?.items),
            products: getNewProductsItems(rmaInfo?.items),
          }}
          fees={{ total: rmaInfo.orderAmount?.fee_amount, fees: rmaInfo.orderAmount?.fees }}
          bonuses={{ total: rmaInfo?.orderAmount?.bonus_amount, bonuses: rmaInfo.orderAmount?.bonuses }}
          isCollapsable={true}
          collapsedByDefault={false}
          reminder={false}
          currency={rmaInfo?.orderAmount?.currency}
          storeCurrency={rmaInfo?.merchantInfo?.currency}
          showMerchantTitle={true}
          customLogisticsLabel={customLogisticsLabel}
        />
        <EditAmountsDrawer
          show={showEditAmountDrawer}
          concepts={getAvailableConcepts({
            refundAmounts: rmaInfo?.orderInfo?.refund_amounts,
            initialSelectedValue: true,
            shippingSummaryAmount: rmaInfo?.orderAmount?.shipping_amount,
            customLogisticsLabel,
            t,
          })}
          lineItems={rmaInfo?.items}
          refundMethods={getRefundMethodsOptions(
            rmaInfo?.orderInfo?.allowed_refund_methods,
            rmaInfo?.orderInfo?.refundType
          )}
          refundMethod={rmaInfo?.orderInfo?.refundType}
          currency={rmaInfo?.orderAmount?.currency}
          onClose={closeEditAmountDrawer}
          onSave={onSaveEditAmounts}
          loading={gettingRmaAmounts}
        />
      </Loading>
    </>
  )
}
export default BreakDown
